import reduce from "lodash/reduce";
import {
  ICheckboxGroupConfig,
  ICheckboxGroupValue,
  IDropdownCheckboxValueItemConfig,
} from "component-library";
import { IStat } from "shared/models/Performers/SearchStats";
import { sortBy } from "lodash";

export function mapOptionsToCheckboxGroupValue(
  checkboxOptions: ICheckboxGroupConfig["options"] = [],
  values: boolean | string[] = false
): ICheckboxGroupValue {
  return checkboxOptions.reduce((result, option) => {
    if ("value" in option) {
      result[option.value] =
        typeof values === "boolean" ? values : values.includes(option.value);
    } else if ("options" in option) {
      result[option.name] = mapOptionsToCheckboxGroupValue(
        option.options,
        values
      );
    }

    return result;
  }, {} as ICheckboxGroupValue);
}

export function mapFacetCheckboxOptions(
  items: IDropdownCheckboxValueItemConfig[] = [],
  options?: {
    isCollapsible?: boolean;
    unwrapGroupCodes?: string[];
    sort?: boolean;
  },
  stats?: Array<IStat<number>>,
  showStats: boolean = false
): IDropdownCheckboxValueItemConfig[] {
  const mappedItems = items.reduce((result, item) => {
    let statCount: number | undefined;
    let isDisabled: boolean | undefined;
    if (stats && stats.length === 0) {
      statCount = 0;
      isDisabled = true;
    } else if (stats && showStats) {
      let facetStat: IStat<number> | undefined;

      facetStat = stats.find(
        (statItem: IStat<number>) => statItem.value === Number(item.value)
      );

      statCount = facetStat?.count ?? 0;

      isDisabled = statCount === 0;
    }

    if (!stats && showStats) {
      isDisabled = true;
    }

    result.push({
      label: item.label,
      value: String(item.value),
      selectedLabel: "",
      disabled: isDisabled,
      labelPostFix: showStats ? statCount : undefined,
    });

    return result;
  }, [] as IDropdownCheckboxValueItemConfig[]);

  return options?.sort
    ? sortBy(mappedItems, [(subItem) => subItem.label])
    : mappedItems;
}

export function mapNumericOptionsToCheckboxGroupValue(
  checkboxOptions: ICheckboxGroupConfig["options"] = [],
  values: number[] = []
): ICheckboxGroupValue {
  return mapOptionsToCheckboxGroupValue(
    checkboxOptions,
    values.map((value) => String(value))
  );
}

export function mapCheckboxGroupValueToValues(
  values: ICheckboxGroupValue = {}
): string[] {
  return reduce(
    values,
    (result, value, key) => {
      if (typeof value === "boolean") {
        return value ? [...result, key] : result;
      }

      return [...result, ...mapCheckboxGroupValueToValues(value)];
    },
    []
  );
}

export function mapCheckboxGroupValueToNumericValues(
  values: ICheckboxGroupValue = {}
): number[] {
  return mapCheckboxGroupValueToValues(values).map((value) => Number(value));
}
